import React from 'react';
import { useFetch } from '../../../hooks/useFetch';
import Lampara from './Lampara';

function Lamparas() {
  const z = useFetch('https://www.fabrilum.com.ar/backend/getLamparas.php');

  return (
    <section className="mx-auto max-w-7xl px-6 pb-24 md:px-10 md:pb-32">
      <div className="mb-12">
        <p className="eyebrow">
          <span className="h-px w-10 bg-brand-500" />
          Compatibilidad
        </p>
        <h2 className="mt-4 font-display text-4xl font-medium text-ink md:text-5xl">
          Explorá por tipo de lámpara
        </h2>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
        {z.data &&
          z.data[0].map((zoc, i) => (
            <Lampara key={zoc.id} data={zoc} index={i} />
          ))}
      </div>
    </section>
  );
}

export default Lamparas;
